export const DAILY_RENTALS_REQUESTED = 'DAILY_RENTALS_REQUESTED';
export const DAILY_RENTALS_SUCCESS = 'DAILY_RENTALS_SUCCESS';
export const DAILY_RENTALS_FAILED = 'DAILY_RENTALS_FAILED';

export const EDIT_DAILY_RENTAL_REQUESTED = 'EDIT_DAILY_RENTAL_REQUESTED';
export const EDIT_DAILY_RENTAL_FAILED = 'EDIT_DAILY_RENTAL_FAILED';
export const EDIT_DAILY_RENTAL_SUCCESS = 'EDIT_DAILY_RENTAL_SUCCESS';
